<template>
  <div
    v-tooltip="tooltipText"
    data-cy="reset-ringcentral"
    class="h-6 w-6 transform cursor-pointer transition-all duration-300 hover:-rotate-180"
    @click="refreshProviderToken"
  >
    <icon-base :icon="IconReload" height="24" width="24" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import startCase from "lodash/startCase";

import { CommunicationProvider } from "@/enums/communicationProviders";
import { useDialerApiStore } from "@/services/dialer-api";

import IconReload from "@/components/icons/IconReload.vue";

const emit = defineEmits<{
  "ring-central:reset": [];
}>();

const { provider = CommunicationProvider.RingCentral } = defineProps<{
  provider: CommunicationProvider;
}>();

const dialerApi = useDialerApiStore();
const { t } = useI18n();

const tooltipText = computed(() => {
  return t("COMMUNICATION.PINNABLE.REFRESH_PROVIDER_TOKEN", {
    provider: startCase(provider),
  });
});

const refreshProviderToken = () => {
  if (provider === CommunicationProvider.RingCentral) {
    emit("ring-central:reset");
  }

  if (provider === CommunicationProvider.Twilio) {
    dialerApi.getAccessToken();
  }
};
</script>
